import { useState, useCallback } from "react";

const useHttp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendRequest = useCallback(
    async (requestConfig, processResponseData, responseType) => {
      setIsLoading(true);
      setError(null);
      //try {
        const response = await fetch(requestConfig.url, {
          method: requestConfig.method ? requestConfig.method : "GET",
          headers: requestConfig.headers ? requestConfig.headers : {},
          body: requestConfig.body ? JSON.stringify(requestConfig.body) : null,
        });

        if (!response.ok) {
          let errorMsg = "Request failed!";
          if(responseType === 'json'){
            const data = await response.json();
            if(data && data.status === 'fail'){
              errorMsg = data.message;
            }
          }
          throw new Error(errorMsg);
        }

        let data;
        if(responseType === 'json'){
          data = await response.json();
        }else if(responseType === 'text'){
          data = await response.text();
        }

        processResponseData(data);

      setIsLoading(false);
    },
    []
  );
  return {
    isLoading,
    error,
    sendRequest,
  };
};

export default useHttp;
